export class GlobSysInfo {
    /* Classic */
    dqs(iId) { return iId ? document.querySelector('input[name=' + iId + ']') : undefined; }
    get sessionCode() { var _a, _b; return (_b = (_a = this.dqs('SessionCode')) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : ''; }
    get user() { let elm = this.sessionCode; if (elm && elm.split('.').length > 0)
        return elm.split('.')[1];
    else
        return undefined; }
    get moduleId() { var _a, _b; return (_b = (_a = this.dqs('moduleId')) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : ''; }
    get eventid() { var _a, _b; return (_b = (_a = this.dqs('eventid')) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : ''; }
    get systemId() { var _a, _b; return (_b = (_a = this.dqs('SystemId')) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : ''; }
    get subwin() { var _a, _b; return (_b = (_a = this.dqs('Subwin')) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : ''; }
    get program() { let elm = this.subwin; return elm ? elm.split('/').slice(-1) : undefined; }
    get datemode() { var _a, _b; return (_b = (_a = this.dqs('datemode')) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : ''; }
    get webVersion() {
        var _a, _b;
        let wv = (_b = (_a = this.dqs('WebVersion')) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '';
        if (['2.5', '3'].includes(wv))
            return wv;
        return '2.5';
    }
    get isTeamTools() { var _a; return Boolean((_a = GlobSysInfo.dqs('teamTools')) === null || _a === void 0 ? void 0 : _a.value) ? true : false; }
    get appVersion() { return 'r-2.27.0'; }
    ;
    /* Static */
    static dqs(iId) { return iId ? document.querySelector('input[name=' + iId + ']') : undefined; }
    static get sessionCode() { var _a, _b; return (_b = (_a = GlobSysInfo.dqs('SessionCode')) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : ''; }
    static get user() { let elm = GlobSysInfo.sessionCode; if (elm && elm.split('.').length > 0)
        return elm.split('.')[1];
    else
        return undefined; }
    static get moduleId() { var _a, _b; return (_b = (_a = GlobSysInfo.dqs('moduleId')) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : ''; }
    static get eventid() { var _a, _b; return (_b = (_a = GlobSysInfo.dqs('eventid')) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : ''; }
    static get systemId() { var _a, _b; return (_b = (_a = GlobSysInfo.dqs('SystemId')) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : ''; }
    static get subwin() { var _a, _b; return (_b = (_a = GlobSysInfo.dqs('Subwin')) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : ''; }
    static get program() { let elm = GlobSysInfo.subwin; return elm ? elm.split('/').slice(-1) : undefined; }
    static get datemode() { var _a, _b; return (_b = (_a = GlobSysInfo.dqs('datemode')) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : ''; }
    static get webVersion() {
        var _a, _b;
        let wv = (_b = (_a = GlobSysInfo.dqs('WebVersion')) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '';
        if (['2.5', '3'].includes(wv))
            return wv;
        return '2.5';
    }
    static get isTeamTools() { var _a; return Boolean((_a = GlobSysInfo.dqs('teamTools')) === null || _a === void 0 ? void 0 : _a.value) ? true : false; }
    static get appVersion() { return 'r-2.27.0'; }
    ;
}
//# sourceMappingURL=GlobSysInfo.js.map